import React from 'react';
import { Section } from './Section';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'Ritual de 10 Minutos Antes de Dormir',
    desc: 'Rutina lista para aplicar esta misma noche.',
    value: '$8.000'
  }, {
    num: '02',
    title: 'Diario de Descarga Mental',
    desc: 'Plantillas para vaciar la mente antes de acostarte.',
    value: '$7.000'
  }, {
    num: '03',
    title: 'SOS Ansiedad Nocturna',
    desc: 'Protocolo exacto para cuando te despertás a las 3am.',
    value: '$6.000'
  }, {
    num: '04',
    title: 'Audio de Relajación Guiada',
    desc: 'Meditación de 15 minutos para dormirse. Solo reproducís.',
    value: '$9.000'
  }, {
    num: '05',
    title: 'Plan Detox Digital de 7 días',
    desc: 'Cómo reducir el scroll nocturno que activa tu ansiedad.',
    value: '$7.000'
  }];
  return <Section className="bg-bgAlt py-20 px-4 sm:px-6 lg:px-8" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <h2 className="font-serif text-3xl md:text-4xl text-center text-headlineLight mb-16" data-id="element-18">
          <span className="text-goldSoft mr-2" data-id="element-19">🎁</span> 5 Bonos incluidos —
          Listos para usar esta noche
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-20">
          {bonuses.map((bonus, i) => <div key={i} className="gradient-card-bonus rounded-2xl p-6 relative overflow-hidden group hover:brightness-110 transition-all" data-id="element-21">
              <div className="absolute top-0 right-0 bg-ctaFrom text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-22">
                BONO {bonus.num}
              </div>
              <div className="text-mutedPurple text-3xl mb-4 font-serif italic" data-id="element-23">
                {bonus.num}
              </div>
              <h3 className="font-serif text-xl font-bold text-headlineLight mb-3 pr-8" data-id="element-24">
                {bonus.title}
              </h3>
              <p className="text-bodyOnDark text-sm mb-6 min-h-[40px]" data-id="element-25">
                {bonus.desc}
              </p>
              <div className="flex items-center gap-2 text-sm" data-id="element-26">
                <span className="line-through text-mutedPurple" data-id="element-27">
                  {bonus.value}
                </span>
                <span className="text-goldSoft font-bold" data-id="element-28">→ GRATIS</span>
              </div>
            </div>)}
        </div>

        <div className="bg-[rgba(45,27,78,0.4)] border border-goldSoft/30 rounded-2xl p-6 text-center max-w-2xl mx-auto" data-id="element-29">
          <p className="text-lg text-headlineLight" data-id="element-30">
            Valor total bonos:{' '}
            <span className="line-through text-mutedPurple mx-2" data-id="element-31">$37.000</span>
            <span className="text-goldSoft font-bold text-xl" data-id="element-32">
              → GRATIS con tu pack
            </span>
          </p>
        </div>
      </div>
    </Section>;
}